import { render } from "./ManageTitle.vue?vue&type=template&id=540934a8"
import script from "./ManageTitle.vue?vue&type=script&lang=js"
export * from "./ManageTitle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__